/**
 * Вход и обновление сессии (§Т2.8).
 */

import { apiFetch } from "./client.js";

export type AuthTokens = {
  readonly accessToken: string;
  readonly refreshToken: string;
  readonly expiresIn: number;
};

export type RegisterResult = AuthTokens & {
  readonly player: { readonly id: string; readonly nickname: string };
};

export async function register(body: {
  email: string;
  password: string;
  nickname: string;
}): Promise<RegisterResult> {
  return apiFetch<RegisterResult>("/auth/register", {
    method: "POST",
    body: JSON.stringify(body),
    headers: { "Accept-Language": "ru" },
  });
}

export async function login(body: {
  email: string;
  password: string;
}): Promise<AuthTokens> {
  return apiFetch<AuthTokens>("/auth/login", {
    method: "POST",
    body: JSON.stringify(body),
  });
}

export async function refresh(refreshToken: string): Promise<AuthTokens> {
  return apiFetch<AuthTokens>("/auth/refresh", {
    method: "POST",
    body: JSON.stringify({ refreshToken }),
  });
}

export async function verifyEmail(token: string): Promise<{ verified: true }> {
  return apiFetch<{ verified: true }>("/auth/verify-email", {
    method: "POST",
    body: JSON.stringify({ token }),
  });
}

export async function resendVerification(accessToken: string): Promise<{ sent: true }> {
  return apiFetch<{ sent: true }>("/auth/resend-verification", {
    method: "POST",
    token: accessToken,
  });
}
